module.exports = __webpack_public_path__ + "static/chevron-grunge-border-top-e361ab35fab83a6ec0cfe689e912e87e.png";